var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path3, _path4, _path5, _g9, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_1277)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5036 57.3812C17.4521 54.2387 19.1473 50.8389 22.2898 49.7875L96.6633 24.9037C99.8057 23.8523 103.206 25.5475 104.257 28.69L142.069 141.705C143.121 144.847 141.425 148.247 138.283 149.298L63.9095 174.182C60.767 175.233 57.3672 173.538 56.3158 170.396L18.5036 57.3812Z",
    fill: "url(#paint1_linear_26801_1277)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.514 100.461L65.4262 116.674C64.5907 116.962 63.6951 116.56 63.4254 115.777C63.1556 114.993 63.614 114.125 64.4495 113.838L111.537 97.6241C112.372 97.3365 113.268 97.7382 113.538 98.5216C113.808 99.3051 113.349 100.173 112.514 100.461Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.351 79.6593L58.2639 95.8728C57.4284 96.1605 56.5328 95.7588 56.263 94.9753C55.9932 94.1919 56.4517 93.3239 57.2872 93.0362L104.375 76.8227C105.21 76.535 106.106 76.9367 106.375 77.7202C106.645 78.5037 106.187 79.3716 105.351 79.6593Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1977 58.9901L41.0649 78.6624C40.0512 79.0115 39.0019 78.6325 38.7206 77.8156C38.4393 76.9988 39.0329 76.054 40.0466 75.705L97.1793 56.0326C98.1931 55.6835 99.2424 56.0626 99.5237 56.8794C99.805 57.6963 99.2114 58.641 98.1977 58.9901Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6164 48.5894L37.4836 68.2617C36.4699 68.6108 35.4206 68.2318 35.1393 67.4149C34.858 66.5981 35.4516 65.6533 36.4653 65.3043L93.598 45.6319C94.6118 45.2828 95.6611 45.6619 95.9424 46.4787C96.2237 47.2956 95.6301 48.2403 94.6164 48.5894Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.104 110.994L58.9712 130.666C57.9574 131.015 56.9081 130.636 56.6268 129.819C56.3456 129.002 56.9391 128.058 57.9529 127.709L115.086 108.036C116.099 107.687 117.149 108.066 117.43 108.883C117.711 109.7 117.118 110.645 116.104 110.994Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.932 90.06L61.8449 106.274C61.0094 106.561 60.1138 106.159 59.8441 105.376C59.5743 104.593 60.0327 103.725 60.8682 103.437L107.956 87.2235C108.791 86.9358 109.687 87.3375 109.957 88.1209C110.226 88.9044 109.768 89.7723 108.932 90.06Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.779 69.3908L44.6462 89.0632C43.6325 89.4122 42.5832 89.0332 42.3019 88.2163C42.0206 87.3995 42.6142 86.4548 43.6279 86.1057L100.761 66.4333C101.774 66.0843 102.824 66.4633 103.105 67.2802C103.386 68.097 102.793 69.0417 101.779 69.3908Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1187 131.231L62.5525 141.067C61.5387 141.416 60.4894 141.037 60.2081 140.22C59.9269 139.403 60.5204 138.458 61.5342 138.109L90.1004 128.273C91.1142 127.924 92.1635 128.303 92.4448 129.12C92.726 129.937 92.1322 130.882 91.1187 131.231Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6434 117.079C60.2727 118.907 59.3012 120.898 57.4735 121.528C55.6459 122.157 53.6541 121.186 53.0247 119.358C52.3954 117.53 53.3669 115.539 55.1946 114.909C57.0223 114.28 59.0141 115.251 59.6434 117.079ZM54.6794 118.788C54.9941 119.702 55.99 120.188 56.9038 119.873C57.8176 119.558 58.3034 118.563 57.9887 117.649C57.6741 116.735 56.6782 116.249 55.7643 116.564C54.8505 116.879 54.3647 117.874 54.6794 118.788Z",
    fill: "url(#paint2_linear_26801_1277)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0621 106.678C56.6914 108.506 55.7199 110.498 53.8922 111.127C52.0646 111.756 50.0728 110.785 49.4434 108.957C48.8141 107.13 49.7856 105.138 51.6133 104.508C53.441 103.879 55.4328 104.851 56.0621 106.678ZM51.0981 108.388C51.4128 109.301 52.4087 109.787 53.3225 109.472C54.2363 109.158 54.7221 108.162 54.4074 107.248C54.0928 106.334 53.0969 105.848 52.183 106.163C51.2692 106.478 50.7834 107.474 51.0981 108.388Z",
    fill: "url(#paint3_linear_26801_1277)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4808 96.2776C53.1101 98.1053 52.1386 100.097 50.3109 100.726C48.4833 101.356 46.4915 100.384 45.8621 98.5566C45.2328 96.7289 46.2043 94.7371 48.032 94.1078C49.8597 93.4784 51.8515 94.4499 52.4808 96.2776ZM47.5168 97.9868C47.8315 98.9007 48.8274 99.3864 49.7412 99.0717C50.655 98.7571 51.1408 97.7612 50.8261 96.8473C50.5115 95.9335 49.5156 95.4478 48.6017 95.7624C47.6879 96.0771 47.2021 97.073 47.5168 97.9868Z",
    fill: "url(#paint4_linear_26801_1277)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_26801_1277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.1 127.374L113.302 132.973C112.904 133.106 112.525 132.727 112.657 132.329L118.257 115.53C118.507 114.78 118.928 114.099 119.487 113.54L169.535 63.4916C171.524 61.5028 174.749 61.5028 176.737 63.4916L182.139 68.893C184.128 70.8819 184.128 74.1061 182.139 76.095L132.09 126.143C131.531 126.702 130.85 127.124 130.1 127.374Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.537 79.6953L165.934 67.0923L160.778 72.2486L173.381 84.8517L178.537 79.6953Z",
    fill: "url(#paint5_linear_26801_1277)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.036 84.1981L161.433 71.595L119.538 113.49L132.141 126.093L174.036 84.1981Z",
    fill: "url(#paint6_linear_26801_1277)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 124.702L112.658 132.329C112.525 132.727 112.904 133.106 113.302 132.973L120.929 130.431L115.2 124.702Z",
    fill: "url(#paint7_linear_26801_1277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_1277",
    x: 63.3479,
    y: 96.5311,
    width: 50.2673,
    height: 20.2362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_1277",
    x: 56.1855,
    y: 75.7297,
    width: 50.2673,
    height: 20.2362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_1277",
    x: 38.6506,
    y: 54.9028,
    width: 60.9429,
    height: 23.8895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_1277",
    x: 35.0693,
    y: 44.5021,
    width: 60.9429,
    height: 23.8895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_26801_1277",
    x: 56.5569,
    y: 106.906,
    width: 60.9429,
    height: 23.8895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_26801_1277",
    x: 59.7666,
    y: 86.1304,
    width: 50.2673,
    height: 20.2362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_26801_1277",
    x: 42.2319,
    y: 65.3035,
    width: 60.9429,
    height: 23.8895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_26801_1277",
    x: 60.1382,
    y: 127.143,
    width: 32.3765,
    height: 14.0533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1277",
    result: "effect2_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_26801_1277",
    x: 111.63,
    y: 60,
    width: 72,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1277"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1277",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1277",
    x1: 80.2864,
    y1: 24.5921,
    x2: 80.2864,
    y2: 174.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1277",
    x1: 52.6092,
    y1: 115.799,
    x2: 61.9058,
    y2: 117.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1277",
    x1: 49.0279,
    y1: 105.399,
    x2: 58.3245,
    y2: 107.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1277",
    x1: 45.4466,
    y1: 94.998,
    x2: 54.7432,
    y2: 97.1336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1277",
    x1: 165.531,
    y1: 67.4951,
    x2: 161.026,
    y2: 79.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1277",
    x1: 162.811,
    y1: 72.9735,
    x2: 178.695,
    y2: 96.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1277",
    x1: 112.631,
    y1: 125.35,
    x2: 120.54,
    y2: 132.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/Summary.374bfc51933580b6bce3744ee666365b.svg";
export { ForwardRef as ReactComponent };